import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03c80973"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-pic d-flex align-items-center justify-content-center" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "profile-pic",
      src: _ctx.avatarSrc,
      alt: "Tenant Avatar"
    }, null, 8, _hoisted_2)
  ]))
}